module.exports = __webpack_public_path__ + "img/comparison-periods.f02cc290.gif";